export default __webpack_public_path__ + "static/screen_binary_5-a7ace3b5f6cc17e2952115163d90c262.png";